import { filter, map, compose, identity, prop, indexBy } from 'ramda';

export function getAmsOrdering({ segmentsOrdering, segments }) {
  const segmentsTransformedToStrings =
    segments?.map?.((segment) => String(segment)) ?? [];
  const { bySegments, defaultOrder } = segmentsOrdering || {};

  const segment = bySegments?.find?.((item) =>
    segmentsTransformedToStrings?.includes?.(String(item?.segment))
  );

  return segment?.order || defaultOrder || [];
}

function mapOrderIdToWidget(widgetByIds) {
  return function mapper(orderId) {
    return widgetByIds[orderId];
  };
}

export function orderIdToWidget(widgets) {
  const widgetByIds = indexBy(prop('orderId'), widgets);

  return compose(filter(identity), map(mapOrderIdToWidget(widgetByIds)));
}
